export default "__VITE_ASSET__BPJ4TfGY__"